import {Directive, HostBinding, Inject, inject, Injector, OnInit, Optional} from '@angular/core';
import {DISPLAY_TYPE, ImagePipe, IWidgetConfig, Parent, provideAsWidgetRef, register, StylableComponent, styler} from "@wm/components-base";
import {setAttr, setCSS, switchClass} from "@wm/core";

const DEFAULT_CLS = 'app-picture';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-picture',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Directive({
  selector: 'img[wmPicture]',
  standalone: true,
  providers: [
    ImagePipe,
    provideAsWidgetRef(PictureDirective)
  ],
  exportAs: 'wmPicture'
})
export class PictureDirective extends StylableComponent implements OnInit {
  static initializeProps = register('wm-picture');
  private encodeurl: string;
  private pictureplaceholder: string;
  private bindpictureplaceholder: string;
  private bindpicturesource: string;
  @HostBinding('src') imgSource: string;

  constructor(inj: Injector, @Optional() public _viewParent: Parent, @Inject(ImagePipe) private imagePipe: ImagePipe) {
    super(inj, WIDGET_CONFIG, _viewParent);
    styler(this.nativeElement, this);
  }

  setImgSource() {
    if (!this.imagePipe) {
      this.imagePipe = inject(ImagePipe);
    }
    if (this.picturesource?.startsWith('bind:') || this.bindpicturesource) this.picturesource = '';
    if (this.pictureplaceholder?.startsWith('bind:') || this.bindpictureplaceholder) this.pictureplaceholder = '';
    this.imgSource = this.imagePipe.transform(this.picturesource, this.encodeurl, this.pictureplaceholder);

    // TODO: remove this (fetching the images from local proj folder)
    if (this.imgSource.startsWith('resources/images/')) {
      this.imgSource = '/assets/' + this.imgSource;
    }
  }

  override onPropertyChange(key: string, nv: any, ov: any) {
    if (key === 'pictureaspect') {
      let width = '';
      let height = '';
      switch (nv) {
        case 'None':
          width = this.width;
          height = this.height;
          break;
        case 'H':
          width = '100%';
          break;
        case 'V':
          height = '100%';
          break;
        case 'Both':
          width = '100%';
          height = '100%';
          break;
      }
      setCSS(this.nativeElement, 'width', width, true);
      setCSS(this.nativeElement, 'height', height, true);
    } else if (key === 'encodeurl' || key === 'pictureplaceholder') {
      this.setImgSource();
    } else if (key === 'shape') {
      switchClass(this.nativeElement, `img-${nv}`, `img-${ov}`);
    } else if (key === 'resizemode') {
      setCSS(this.nativeElement, 'object-fit', nv);
    } else if(key === 'alttext') {
      setAttr(this.nativeElement,'alt',nv)
    }
    super.onPropertyChange(key, nv, ov);
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'picturesource') {
      this.setImgSource();
    } else {
      super.onStyleChange(key, nv, ov);
    }
  }

  override ngOnInit() {
    this.setImgSource();
    let newval= this.getAttr('alttext.bind');
    if(newval){
      setAttr(this.nativeElement,'alt','bind:'+newval);
    }
    super.ngOnInit();
  }

}
